export interface EnumTranslation {
  readonly description: string;
  readonly order: number;
  readonly deprecated?: boolean;
}

export interface TranslatedEnum<T> extends EnumTranslation {
  readonly value: T;
}

export function getInvalidEnumTranslation<T extends string>(invalidValue: T | never): EnumTranslation {
  return {
    description: invalidValue,
    order: 999,
  };
}

export function getSortedTranslations<T>(
  values: readonly T[],
  translator: (val: T) => EnumTranslation,
): TranslatedEnum<T>[] {
  return values.map(value => ({ value, ...translator(value) })).sort((a, b) => a.order - b.order);
}
